  	
import axios from 'axios'

const id="webClient"
const baseURL = "https://kapi.iglor.es/v1"

export function parsePayload(payload){
    let data = {}

    data.id = payload.aref
    //data.name = label
    //data.bgColor = "#4f5a61"
    //data.textColor = "#ffffff"
    data.module = payload.module
    data.type = payload.value
    data.value = payload.data.file
    data.defaultSound = payload.data['default-sound']
    data.bgColorRemote = payload.data['background-color']
    console.log(payload.data)
    if(payload.data['vibration'] == "1")
        data.vibration = true
    else
        data.vibration = false
    
    data.loop = payload.data['media-loop']
    //data.isActive = false
    data.filters = payload.filters
    //data.targetDevice = 'smartphone'

    return data
}

export async function subscribeToChannel(uuid,channelName){
    let response = {}
    let bodyData = {}
    bodyData.cname = channelName

    try{
        response = response = await axios.post(baseURL + '/public/users/'+uuid+'/channels',bodyData,{headers: {"Content-Type": "application/json"}} )
        return response
    }catch(error){
        console.log("Error creating the subscription",error.response)
        return false
    }
}

export async function getMedias(uuid,channelName){
    let response = {}
    let bodyData = {}
    bodyData.cname = channelName
    try{
        response = response = await axios.get(baseURL + '/public/users/'+uuid+'/channels/'+channelName+'/medias',{headers: {"Content-Type": "application/json"}} )
        return response
    }catch(error){
        console.log("Error getting medias",error.response)
        return false
    }
}


// export async function getFormsData(uuid,channelName){
//     let response = {}
//     let bodyData = {}
//     bodyData.cname = channelName

//     try{
//         response = response = await axios.post(baseURL + '/public/users/'+uuid+'/channels/'+channelName+'/form',bodyData,{headers: {"Content-Type": "application/json"}} )
//         return response
//     }catch(error){
//         console.log("Error getting Forms",error.response)
//         return false
//     }
// }

export async function createPublicUser(){
    let data = {}
    let bodyData = {}
    let response = {}

    data['uuid'] = id
    data['device_type'] = "browser"
    data['push_uuid'] = null
    data['hardware'] = null
    data['so'] = null
    data['first_name'] = "-"
    data['last_name'] = "-"
    data['gender'] = "-"
    data['age'] = "-"
    data['country'] = "-"
    data['language'] = "-"
    data['email'] = "a@a.com"
    data['phone'] = "-"
    data['picture'] = "-"
    
    bodyData['public_user'] = data

    try{
        response = await axios.post(baseURL + '/public/users',bodyData,{headers: {"Content-Type": "application/json"}} )
        return response
    }catch(error){
        console.log(error)    
        return false
    }
    
}

export function getChannelInfo(){

}
